import { render, staticRenderFns } from "./CancelInsuranceForm.vue?vue&type=template&id=22f093cc&"
import script from "./CancelInsuranceForm.vue?vue&type=script&lang=js&"
export * from "./CancelInsuranceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports